<template>
  <div class="change">
    <div class="mbx">
      <Breadcrumb :path="path"></Breadcrumb>
    </div>
    <div class="fl"></div>
    <div class="change-conten">
      <van-form ref="vantForm">
        <van-field
          v-model="oldPassword"
          :type="type3 ? 'password' : 'text'"
          center
          placeholder="请输入旧密码"
          :rules="[
            {
              validator: oldPasswordYz,
              message: '请使用字母或数字，长度不低于6位',
            },
          ]"
          name="oldPassword"
        >
          <template #button>
            <div @click="changeType3">
              <img
                src="@/assets/img/形状_1 (1).png"
                alt=""
                style="width: 19px; height: 8px"
                v-if="type3"
              />
              <img
                src="@/assets/img/形状_2.png"
                alt=""
                style="width: 23px; height: 14px"
                v-else
              />
            </div>
          </template>
        </van-field>
        <van-field
          v-model="newPassword"
          name="newPassword"
          :type="type1 ? 'password' : 'text'"
          center
          placeholder="请输入新密码"
          :rules="[
            {
              validator: newPasswordYz,
              message: '请使用字母或数字，长度不低于6位',
            },
          ]"
        >
          <template #button>
            <div @click="changeType1">
              <img
                src="@/assets/img/形状_1 (1).png"
                alt=""
                style="width: 19px; height: 8px"
                v-if="type1"
              />
              <img
                src="@/assets/img/形状_2.png"
                alt=""
                style="width: 23px; height: 14px"
                v-else
              />
            </div>
          </template>
        </van-field>
        <van-field
          v-model="newPasswords"
          name="newPasswords"
          :type="type2 ? 'password' : 'text'"
          center
          placeholder="请重复新密码"
          :rules="[{ validator: PasswordsYz, message: '两次密码不一致' }]"
          style="margin-bottom: 40px"
        >
          <template #button>
            <div @click="changeType2">
              <img
                src="@/assets/img/形状_1 (1).png"
                alt=""
                style="width: 19px; height: 8px"
                v-if="type2"
              />
              <img
                src="@/assets/img/形状_2.png"
                alt=""
                style="width: 23px; height: 14px"
                v-else
              />
            </div>
          </template>
        </van-field>
        <div class="change-conten-button">
          <button class="change-conten-button-left" @click="change">
            确认修改
          </button>
          <button class="change-conten-button-right" @click.stop="cancellation">
            取消
          </button>
        </div>
      </van-form>
    </div>
  </div>
</template>

<script>
import { $change_password } from "@/api";
import { message } from "ant-design-vue";
import Breadcrumb from "@/components/Breadcrumb.vue";
export default {
  data() {
    return {
      type3: true, // 控制 旧密码框/输入框
      type1: true, // 控制 密码框/输入框
      type2: true, // 控制 确认密码框/输入框
      oldPassword: "", // 旧密码
      newPassword: "", // 新密码
      newPasswords: "", // 确认密码
    };
  },
  mounted() {
    window.onresize = () => {
      return (() => {
        this.$nextTick(() => {
          if (document.documentElement.clientWidth < 767) {
            this.$router.push({ name: "changes" });
          }
        });
      })();
    };
  },
  beforeDestroy() {
    window.onresize = null;
  },
  computed: {
    path() {
      let arr = [
        { name: "我的", names: "feedback" },
        { name: "修改密码", names: "change" },
      ];
      return arr;
    },
  },
  components: {
    Breadcrumb,
  },
  methods: {
    // 旧密码验证
    oldPasswordYz(val) {
      return /^(?=.*[0-9])(?=.*[a-zA-Z])[a-zA-Z0-9.!@#$%^&*()_+?<>:;]{6,20}$/.test(
        val
      );
    },
    // 验证新密码
    newPasswordYz(val) {
      return /^(?=.*[0-9])(?=.*[a-zA-Z])[a-zA-Z0-9.!@#$%^&*()_+?<>:;]{6,20}$/.test(
        val
      );
    },
    // 验证重复密码
    PasswordsYz(val) {
      if (val == "") {
        return false;
      }
      return this.newPassword == val;
    },
    // 切换旧密码的后缀图标
    changeType3() {
      this.type3 = !this.type3;
    },
    // 切换新密码的后缀图标
    changeType1() {
      this.type1 = !this.type1;
    },
    // 切换确认密码的后缀图标
    changeType2() {
      this.type2 = !this.type2;
    },
    // 点击确认修改
    async change() {
      try {
        let params = {
          old_psw: this.oldPassword,
          new_psw: this.newPassword,
          confirm_psw: this.newPasswords,
        };
        let res = await $change_password(params);
        message.success("修改成功,请重新登陆", 1);
        setTimeout(() => {
          this.$router.push({ name: "Login" });
        }, 1500);
      } catch (error) {
        message.error(error.msg);
      }
    },
    // 点击取消
    cancellation() {
      this.$router.go(0);
    },
  },
};
</script>

<style lang="less" scoped>
.change {
  .mbx {
    padding-top: 30px;
    padding-left: 37px;
    margin-bottom: 21px;
  }

  .fl {
    width: 98%;
    height: 1px;
    background: #e9e9e9;
    margin: 0 auto;
    margin-bottom: 51px;
  }

  .change-conten {
    width: 40%;
    margin: 0 auto;

    /deep/.van-cell {
      margin-bottom: 20px;
      border: 1px solid #cfcfcf;
    }

    /deep/.van-field__button {
      img {
        cursor: pointer;
        width: 14px;
        height: 14px;
      }
    }

    /deep/.van-field__control {
      font-size: 18px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #999999;
    }

    .change-conten-button {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .change-conten-button-left {
        cursor: pointer;
        width: 47%;
        height: 47px;
        background: #e60012;
        border-radius: 4px;
        font-size: 20px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #ffffff;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .change-conten-button-right {
        cursor: pointer;
        width: 47%;
        height: 47px;
        background: #e1e1e1;
        border-radius: 4px;
        font-size: 20px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #666666;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }
}
</style>
